module.exports = __webpack_public_path__ + "img/logo.ad95bf28.png";